import { getWindowLocationHref } from '../routing/getWindowLocationHref';
import { getQueryParam } from '../routing/getQueryParam';
export const getLoginRedirectUrl = () => {
  const loginRedirectUrl = getQueryParam('loginRedirectUrl');
  return loginRedirectUrl || getWindowLocationHref();
};